import UniteTestimonialBlockView from './View';

export const UniteTestimonialBlockEdit = (props) => {
  return <UniteTestimonialBlockView {...props} />;
};

export default UniteTestimonialBlockEdit;
